module.exports = __webpack_public_path__ + "static/avenir-regular-12bc53a036712506e157f25eb88fd957.woff2";